import React from "react";
import { GiftPurchaseItem, Purchase } from "types";
import { Currency } from "@/components/Common/Currency";
import { NoTranslate } from "@/components/Common/NoTranslate";

interface GiftPurchaseSummaryProps {
    purchase: Purchase;
    item: GiftPurchaseItem;
}

export const GiftPurchaseSummary = ({ purchase, item }: GiftPurchaseSummaryProps) => {
    const { customerName } = purchase;
    const { recipientName } = item;

    if (!customerName && !recipientName) {
        return null;
    }

    if (!customerName) {
        return (
            <div data-testid="gift-purchase-summary">
                A{" "}
                <var data-var="amount">
                    <Currency>{item.amount}</Currency>
                </var>{" "}
                gift for <NoTranslate as="span">{recipientName}</NoTranslate>
            </div>
        );
    }

    return (
        <div data-testid="gift-purchase-summary">
            <NoTranslate as="span">{customerName}</NoTranslate> purchased a{" "}
            <var data-var="amount">
                <Currency>{item.amount}</Currency>
            </var>{" "}
            gift
            {recipientName && (
                <>
                    {" "}
                    for <NoTranslate as="span">{recipientName}</NoTranslate>
                </>
            )}
        </div>
    );
};
